import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import '../../../../../utils/Payment.css';
import { Form, Input, Checkbox, Spin } from 'antd';
import InfoTooltip from '../InfoTooltip/InfoTooltip';
import { LoginForm } from 'components';
import { device, Modal, H2 } from 'utils';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { store } from 'react-notifications-component';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import config from 'config';
import { buildRewardSelection } from 'utils/rewardSelection';
import StripeForm from './components/StripeForm';
import RecurringPaymentForm from './components/RecurringPaymentForm';
import isEmpty from 'loadsh/isEmpty';
import { useSelector, useDispatch } from 'react-redux';
import StripeApplePay from './components/ApplePay';
import { paymentConstants } from 'redux/actions/types';
import { useLocation, useParams } from 'react-router-dom';
import ExternalLink from 'components/ExternalLink/ExternalLink';

import StarIcon from '../../../../Project/v2/components/DetailComponents/Icons/personal/Star';
import HandIcon from '../../../../Project/v2/components/DetailComponents/Icons/personal/Strong';
import HeartIcon from '../../../../Project/v2/components/DetailComponents/Icons/personal/Heart';
import Star2Icon from '../../../../Project/v2/components/DetailComponents/Icons/personal/Star2';
import QuranIcon from '../../../../Project/v2/components/DetailComponents/Icons/personal/Quran';
import MosqueIcon from '../../../../Project/v2/components/DetailComponents/Icons/personal/Mosque';
import LightsIcon from '../../../../Project/v2/components/DetailComponents/Icons/personal/Lights';
import HijabIcon from '../../../../Project/v2/components/DetailComponents/Icons/personal/Hijab';
import HaciIcon from '../../../../Project/v2/components/DetailComponents/Icons/personal/Haci';

import FingerIcon from '../../../../Project/v2/components/DetailComponents/Icons/personal/Finger';




import { SupportListItem } from '../../../../Project/v2/components/DetailComponents/SupportListItem';
import moment from 'moment';

const StyledSelect = styled.select`
  box-sizing: border-box;
  width: 100%;
  height: 64px;
  padding: 8px 52px 8px 20px;
  border: 1px solid #dcdcdc;
  border-radius: 10px;
  background: #fff;
  color: #414651;
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 400;
  text-align: left;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-shadow: none;

  &:focus {
    border-color: #95bd51;
  }

  @media ${device.allMobile} {
    height: 56px;
    font-size: 16px;
    padding-right: 44px;
  }
`

const SelectWrapper = styled.div`
  position: relative;
  width: 100%;

  .selected-key {
    display: block;
    width: 100%;
  }

  .arrow-symbol {
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
    color: #6e6e6e;
    pointer-events: none;
    display: flex;
    align-items: center;
  }

  @media ${device.allMobile} {
    .arrow-symbol {
      right: 16px;
    }
  }
`
const InfoFormWrapper = styled.div`
  @media ${device.allMobile} {
    margin-top: 0;
  }

  .ant-select-selector {
    border-radius: 10px !important;
    padding: 6.5px 11px !important;
    height: auto !important;
  }

  button {
    margin-top: 15px;

    @media ${device.allMobile} {
      margin-top: 10px;
    }
  }

  .info-input {
    label {
      display: none;
    }
  }

  .payment-options {
    display: flex;

    span {
      cursor: pointer;

      & + span {
        margin-left: 25px;
      }
    }
  }

  .remove-header {
    @media ${device.allMobile} {
      margin: 0;
      font-size: 4px;
      padding: 0;
    }
  }

  .remove-label {
    .ant-form-item-label {
      display: none;
    }
  }

  .ant-form-item {
    @media ${device.allMobile} {
      margin-bottom: 8px;
    }
  }

  .ant-row,
  .ant-form-item-row {
    width: 100% !important;
  }

  .zahlungsmethode {
    margin-top: 8px;

    h2 {
      margin: 0 0 12px;
      font-family: 'Inter', sans-serif;
      font-weight: 600;
      font-size: 18px;
      line-height: 28px;
      color: rgba(0, 0, 0, 0.85);
    }
  }

  .payment_container {
    margin-top: 28px;
  }

  .payment_label_heading {
    margin: 0 0 12px;
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    color: rgba(0, 0, 0, 0.85);
  }

  .secure_message {
    margin-bottom: 14px;
    padding: 12px 16px;
    background: #def7ec;
    border-radius: 8px;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.85);
  }

  .response_message {
    margin-bottom: 14px;
    padding: 12px 16px;
    background: #fff1f0;
    border: 1px solid #ffccc7;
    border-radius: 8px;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    line-height: 20px;
    color: #cf1322;
  }

  .personal-base-input.ant-input,
  .personal-base-textarea.ant-input {
    box-sizing: border-box;
    width: 100%;
    border: 1px solid #d5d7da;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
    font-family: 'Inter', sans-serif;
    color: #414651;
  }

  .personal-base-input.ant-input {
    height: 40px;
    padding: 8px 12px;
    font-size: 16px;
  }

  .personal-base-textarea.ant-input {
    min-height: 72px;
    padding: 10px 12px;
    /* Prevent iOS Safari from zooming the page while this field is focused. */
    font-size: 16px;
  }

  .compact-checkbox {
    margin-bottom: 8px;
  }

  .compact-checkbox .ant-checkbox-wrapper {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    line-height: 20px;
    color: #414651;
  }

  .compact-checkbox a {
    color: #9dbc60;
    text-decoration: underline;
    margin: 0 3px;
  }
`;

const PreviewSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  /* 32px between checkout sections, like the gap between "Goodies" and the voluntary contribution */
  margin-top: 32px;

  > h2 + * {
    margin-top: -16px;
  }
`;

const SectionHeading = styled.h2`
  margin: 0 0 16px 0;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
`;

const PreviewCard = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 16px;
  gap: 12px;
  width: 100%;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid #f0f0f0;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.09);
  border-radius: 12px;
`;

const PreviewAvatar = styled.div`
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 9999px;
  background: ${({ $bg }) => $bg || '#fff4ed'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ $color }) => $color || '#ff9c66'};
  font-size: 20px;
`;

const PreviewContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

const PreviewTitle = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #3f621a;
  word-break: break-word;
`;

const PreviewMessage = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #717680;
  word-break: break-word;
`;

const PreviewTime = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #717680;
`;

const PersonalizeTriggerWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
`;

const PersonalizeButton = styled.button`
  border: none;
  background: transparent;
  padding: 0 !important;
  cursor: pointer;
  margin-top: 0 !important;

  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #3f621a;

`;

const PersonalizeHint = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.85);
  text-align: center;
`;

// Section heading with a "?" tooltip, built like the "Rhythmus" label in Donation.js
const HeadingRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;

  h2 {
    margin: 0;
  }
`;

const HeadingWithInfo = ({ children, info, style }) => (
  <HeadingRow style={style}>
    <SectionHeading>{children}</SectionHeading>
    {info && <InfoTooltip text={info} />}
  </HeadingRow>
);

const PersonalizePanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 20px;
  background: #f5fbee;
  border-radius: 16px;
  
`;

const PersonalizeLabel = styled.div`
  margin-bottom: 6px;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #414651;
`;

const AvatarRow = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;

  @media ${device.allMobile} {
    display: grid;

    grid-template-columns: repeat(3, 1fr);

    gap: 12px;

    justify-items: center;
  }
`;

const AvatarOption = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 9999px;
  border: ${({ $active }) =>
    $active ? '2px solid #669F2A' : '1px solid #E5E7EB'};
  background: ${({ $bg }) => $bg || '#fff'};
  color: ${({ $color }) => $color || '#111'};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0 !important;
  margin-top: 0 !important;
  font-size: 16px;
`;

const PersonalizeGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
`;

const PersonalizeField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  select {
    box-sizing: border-box;
    width: 100%;
    border: 1px solid #d5d7da;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    color: #414651;
    height: 40px;
    padding: 8px 12px;
  }
`;

const CharCount = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  line-height: 18px;
  color: #717680;
`;

const PanelFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const FooterTextButton = styled.button`
  border: none;
  background: transparent;
  padding: 0 !important;
  margin-top: 0 !important;
  cursor: pointer;

  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: ${({ $green }) => ($green ? '#3F621A' : '#535862')};
`;

const notification = {
  insert: 'top',
  container: 'top-right',
  animationIn: ['animate__animated animate__fadeIn'],
  animationOut: ['animate__animated animate__fadeOut'],
  dismiss: {
    duration: 5000,
    onScreen: true,
  },
};

const formValidateMessages = {
  required: '${label} ist erforderlich. ',
  types: {
    email: 'Keine gültige E-Mail!',
    number: '${label} is not a valid number!',
  },
};

const stripePromise = loadStripe(config.REACT_APP_STRIPE_KEY);


const avatarOptions = [
  {
    key: 'star',
    icon: <StarIcon />,
    bg: '#EDFCF2',
    color: '#73E2A3',
  },
  {
    key: 'heart',
    icon: <HeartIcon />,
    bg: '#FDF2FA',
    color: '#FAA7E0',
  },
  {
    key: 'star2',
    icon: <Star2Icon />,
    bg: '#F4F3FF',
    color: '#BDB4FE',
  },
  {
    key: 'finger',
    icon: <FingerIcon />,
    bg: '#F8F9FC',
    color: '#717BBC',
  },
  {
    key: 'haci',
    icon: <HaciIcon />,
    bg: '#EFF8FF',
    color: '#84CAFF',
  },
  {
    key: 'hijab',
    icon: <HijabIcon />,
    bg: '#FDF2FA',
    color: '#FAA7E0',
  },
  {
    key: 'mosque',
    icon: <MosqueIcon />,
    bg: '#FFF4ED',
    color: '#FF9C66',
  },
  {
    key: 'quran',
    icon: <QuranIcon />,
    bg: '#F7F5F3',
    color: '#79573A',
  },
  {
    key: 'lights',
    icon: <LightsIcon />,
    bg: '#FEFBE8',
    color: '#FAC515',
  }
];

const neutralAvatarOptions = avatarOptions.filter(
  ({ key }) => key !== 'haci' && key !== 'hijab'
);

const pickNeutralAvatar = () =>
  neutralAvatarOptions[Math.floor(Math.random() * neutralAvatarOptions.length)]
    .key;

const getAvatarForCustomName = (customName, currentAvatar, defaultAvatar) => {
  if (customName === 'Ein Bruder im Herzen') return 'haci';
  if (customName === 'Eine Schwester im Herzen') return 'hijab';

  return ['haci', 'hijab'].includes(currentAvatar)
    ? defaultAvatar
    : currentAvatar;
};

const PaymentMethod = ({
  project_id,
  amount,
  tips,
  selectedRewards,
  project,
  supportLevelId,
  embeddedAction,
  onProcessingChange,
  showSummary
}) => {
  const { search } = useLocation();

  const utm_campaign =
    new URLSearchParams(search).get('utm_campaign') ||
    sessionStorage.getItem('utm_campaign');

  const utm_source =
    new URLSearchParams(search).get('utm_source') ||
    sessionStorage.getItem('utm_source');

  const utm_medium =
    new URLSearchParams(search).get('utm_medium') ||
    sessionStorage.getItem('utm_medium');

  const utm_term =
    new URLSearchParams(search).get('utm_term') ||
    sessionStorage.getItem('utm_term');

  const utm_content =
    new URLSearchParams(search).get('utm_content') ||
    sessionStorage.getItem('utm_content');

  const utm_adgroup =
    new URLSearchParams(search).get('utm_adgroup') ||
    sessionStorage.getItem('utm_adgroup');

  const utm_placement =
    new URLSearchParams(search).get('utm_placement') ||
    sessionStorage.getItem('utm_placement');

  const utm_device =
    new URLSearchParams(search).get('utm_device') ||
    sessionStorage.getItem('utm_device');

  const utm_audience =
    new URLSearchParams(search).get('utm_audience') ||
    sessionStorage.getItem('utm_audience');

  const utm_geo =
    new URLSearchParams(search).get('utm_geo') ||
    sessionStorage.getItem('utm_geo');

  const utm_creative =
    new URLSearchParams(search).get('utm_creative') ||
    sessionStorage.getItem('utm_creative');

  const utm_network =
    new URLSearchParams(search).get('utm_network') ||
    sessionStorage.getItem('utm_network');

  const utm_id =
    new URLSearchParams(search).get('utm_id') ||
    sessionStorage.getItem('utm_id');

  const [stripe, setStripe] = useState(null);
  const [elements, setElements] = useState(null);
  const [message, setMessage] = useState(null);
  const [paymentType, setPaymentType] = useState('card');
  const [showPayButton, setShowPayButton] = useState(true);
  const [clientSecret, setClientSecret] = useState(null);
  const [, setTotalAmount] = useState(0);
  const [isProcessing, setIsProcessingState] = useState(false);
  const [, setStripeBtn] = useState(true);
  const [userData, setUserData] = useState({});
  const [goodiesRequiresAddress, setGoodiesRequiresAddress] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [, setTokenId] = useState('');
  const [paymentId, setPaymentId] = useState('');
  const [customer, setCustomer] = useState('');
  const [doPayment, setDoPayment] = useState(false);
  const [recurringPayment, setRecurringpayment] = useState(false);
  const [showLotteryModal, setShowLotteryModal] = useState(false);
  const [selectedKey, setSelectedKey] = useState(project?.title === 'freitag' ? 4 : 0);
  const [paymentIntentId, setPaymentIntentId] = useState(null);
  const [showStripeForm, setShowStripeForm] = useState(true);
  const [termsCheck, setTermsCheck] = useState(true);
  const intentCreateRequestRef = useRef(0);



  const [showPersonalization, setShowPersonalization] = useState(false);

  const setIsProcessing = useCallback(
    (value) => {
      setIsProcessingState(value);
      onProcessingChange?.(value);
    },
    [onProcessingChange]
  );

  useEffect(() => {
    return () => {
      onProcessingChange?.(false);
    };
  }, [onProcessingChange]);

  const donationType = useSelector((state) => state.payment.donationType);
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const FormItem = Form.Item;

  const user = JSON.parse(localStorage.getItem('user'));
  const client = localStorage.getItem('client');
  const uid = localStorage.getItem('uid');
  const access = localStorage.getItem('access-token');
  const isLoggedIn =
    user && !isEmpty(user) && access && uid && client ? true : false;

  // IDs, quantities and answers must all describe the current basket.
  // rewardId in the URL is only a navigation hint and can be stale.
  const { rewardIds: rewards, rewardQuantities, answers: rewardAnswers } = useMemo(
    () => buildRewardSelection(selectedRewards),
    [selectedRewards]
  );
  const getStoredJson = (key, fallback) => {
    const stored = localStorage.getItem(key);

    if (stored == null || stored === 'null' || stored === 'undefined') {
      return fallback;
    }

    try {
      const parsed = JSON.parse(stored);
      return parsed ?? fallback;
    } catch (_) {
      return fallback;
    }
  };
  const getStoredRewards = () => getStoredJson('rewards', []);
  const getStoredRewardQuantities = () => {
    const parsed = getStoredJson('reward_quantities', {});
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
      ? parsed
      : {};
  };
  const getCurrentAnswersForPayload = () => rewardAnswers;
  const getStoredAnswersForPayload = () =>
    buildRewardSelection(getStoredJson('answers', [])).answers;
  const getRewardQuantity = (reward) => Number(reward?.quantity || 1);
  const getRewardTotalPrice = (reward) =>
    Number(reward?.price || 0) * getRewardQuantity(reward);
  const selectedRewardsTotal =
    selectedRewards?.reduce(
      (prev, reward) => prev + getRewardTotalPrice(reward),
      0
    ) || 0;
  const parsedAmount = Number(amount);
  const storedAmount = Number(localStorage.getItem('amount'));
  const donationAmount = Number.isFinite(parsedAmount)
    ? parsedAmount
    : Number.isFinite(storedAmount)
      ? storedAmount
      : 0;
  const previewTotalAmount = donationAmount + selectedRewardsTotal;
  const getRewardsPriceParam = () =>
    selectedRewards.reduce(
      (prev, reward) => `${prev}${getRewardTotalPrice(reward)},`,
      ''
    );
  const getUrl = window.location.href;
  const searchParams = new URLSearchParams(document.location.search);
  const account_id = searchParams.get('PayerID');
  const payment_id = searchParams.get('paymentId');
  const payment_intent = searchParams.get('payment_intent');
  const data = JSON.parse(localStorage.getItem('after_redirect'));

  useEffect(() => {
    if (
      payment_id == null &&
      payment_intent == null &&
      selectedRewards.length === 0
    ) {
      localStorage.removeItem('answers');
      localStorage.removeItem('rewards');
      localStorage.removeItem('reward_quantities');
      localStorage.removeItem('goodies');
    }
  }, [payment_id, payment_intent, selectedRewards.length]);

  const [defaultNeutralAvatar] = useState(pickNeutralAvatar);
  const [formValues, setFormValues] = useState({
    first_name: '',
    last_name: '',
    email: '',
    anonymous: false,
    custom_name: 'Eine herzliche Seele',
    custom_defined_name: '',
    custom_city: '',
    custom_message: '',
    selected_avatar: defaultNeutralAvatar,
  });

  const getFirstName = (values = formValues) =>
    values.first_name ?? user?.first_name ?? values.first_name ?? '';

  const getLastName = (values = formValues) =>
    values.last_name ?? user?.last_name ?? values.last_name ?? '';

  const resolveCustomName = (values = formValues) => {
    const firstName = getFirstName(values);

    const lastName = getLastName(values);

    if (values.custom_name === 'ownName') {
      return `${firstName} ${lastName}`.trim();
    }

    if (values.custom_name === 'ownN') {
      return `${firstName} ${lastName?.charAt(0) || ''}.`.trim();
    }

    if (values.custom_name === 'ownDefine') {
      return values.custom_defined_name?.trim() || '';
    }

    return values.custom_name?.trim() || '';
  };

  const options = {
    appearance: { theme: 'stripe' },
    clientSecret,
  };

  const selected_avatarMeta = useMemo(() => {
    return (
      avatarOptions.find((item) => item.key === formValues.selected_avatar) ||
      avatarOptions[0]
    );
  }, [formValues.selected_avatar]);

  const previewDonationAmount = useMemo(() => {
    return previewTotalAmount.toFixed(2).replace('.', ',');
  }, [previewTotalAmount]);

  const previewNameToShow = resolveCustomName(formValues);
  const previewCityToShow = formValues.custom_city?.trim();
  const previewMessageToShow =
    formValues.custom_message?.trim();

  const extractRewards = () => {
    const rewards_test = {};
    selectedRewards?.forEach((reward) => {
      if (!rewards_test.hasOwnProperty(reward.id)) {
        rewards_test[reward.id] = [];
      }
      rewards_test[reward.id]?.push(reward.answers);
    });
  };

  useEffect(() => {
    const requestId = intentCreateRequestRef.current + 1;
    intentCreateRequestRef.current = requestId;
    setClientSecret(null);
    setPaymentIntentId(null);
    setStripe(null);
    setElements(null);

    const timer = setTimeout(() => {
      fetch('payments/intent_create', {
        method: 'POST',
        body: JSON.stringify({
          amount: donationAmount,
          project_id,
          tips,
          reward_ids: rewards,
          reward_quantities: rewardQuantities,
        }),
      })
        .then((res) => {
          if (intentCreateRequestRef.current !== requestId) return;

          localStorage.setItem(
            'payment_intent_id',
            JSON.stringify(res.payment_intent.id)
          );
          setPaymentIntentId(res.payment_intent.id);
          setClientSecret(res.payment_intent.client_secret);
        })
        .catch((err) => {
          if (intentCreateRequestRef.current !== requestId) return;

          setMessage(err);
          console.log(err);
        });
    }, 800);

    return () => clearTimeout(timer);
  }, [donationAmount, project_id, rewards, rewardQuantities, tips]);

  const updateIntentHandle = (isAnonymous) => {
    if (!paymentIntentId) return;

    const _answer = getCurrentAnswersForPayload();

    return fetch(`payments/intent_update?id=${paymentIntentId}`, {
      method: 'PUT',
      body: JSON.stringify({
        payment_intent: {
          custom_name: resolveCustomName(formValues),
          custom_city: formValues.custom_city?.trim() ?? '',
          custom_message: formValues.custom_message?.trim() ?? '',
          support_level_id: supportLevelId,
          selected_avatar: formValues.selected_avatar || '',
          first_name:
            user?.first_name == null ? formValues.first_name : user?.first_name,
          last_name:
            user?.last_name == null ? formValues.last_name : user?.last_name,
          email: user?.email == null ? formValues.email : user?.email,
          user: true,
          project_id,
          amount: donationAmount,
          lottery: false,
          utm_campaign: utm_campaign || null,
          utm_source: utm_source || null,
          utm_medium: utm_medium || null,
          utm_term: utm_term || null,
          utm_content: utm_content || null,
          utm_adgroup: utm_adgroup || null,
          utm_placement: utm_placement || null,
          utm_device: utm_device || null,
          utm_audience: utm_audience || null,
          utm_geo: utm_geo || null,
          utm_creative: utm_creative || null,
          utm_network: utm_network || null,
          utm_id: utm_id || null,
          anonymous: formValues.anonymous || isAnonymous || false,
          donation_type:
            project.title === 'Ramdan2025' ||
            project.title === 'dh25' ||
            project.title === 'Ramdan2026'
              ? 1
              : selectedKey,
          tips,
          ...(selectedRewards.length !== 0 && {}),
          recurring: selectedKey === 0 ? false : true,
          reward_quantities: rewardQuantities,
          answers: _answer || [],
        },
        reward_ids: rewards,
      }),
      redirect: 'follow',
    });
  };

  const onFinish = (formSubmittedValues) => {
    const values = {
      ...formValues,
      ...formSubmittedValues,
      support_level_id: supportLevelId,
    };

    extractRewards();
    setUserData(values);
    localStorage.setItem('user_data', JSON.stringify(values));
    localStorage.setItem('title', project.title ?? '');

    if (
      (paymentType === 'card' &&
        values &&
        selectedKey === 0 &&
        !recurringPayment) ||
      (paymentType === 'card' &&
        values &&
        recurringPayment &&
        selectedKey !== 0) ||
      (paymentType === 'card' &&
        values &&
        !recurringPayment &&
        selectedKey !== 0)
    ) {
      localStorage.setItem('tips', JSON.stringify(tips));
      localStorage.setItem('amount', JSON.stringify(donationAmount));
      localStorage.setItem('donation_type', JSON.stringify(selectedKey));
      setIsProcessing(true);

      const userLocal = JSON.parse(localStorage.getItem('user'));
      const _answer = getCurrentAnswersForPayload();

      fetch(`payments/intent_update?id=${paymentIntentId}`, {
        method: 'PUT',
        body: JSON.stringify({
          payment_intent: {
            first_name:
              userLocal?.first_name == null
                ? values.first_name
                : userLocal?.first_name,
            last_name:
              userLocal?.last_name == null
                ? values.last_name
                : userLocal?.last_name,
            email: userLocal?.email == null ? values.email : userLocal?.email,
            custom_name: resolveCustomName({
              ...formValues,

              ...values,
            }),
            custom_city: values.custom_city?.trim() ?? '',
            custom_message: values.custom_message?.trim() ?? '',
            support_level_id: values.support_level_id,
            selected_avatar: formValues.selected_avatar || '',
            user: true,
            project_id,
            amount: donationAmount,
            lottery: values?.lottery || false,
            anonymous: values.anonymous || false,
            donation_type:
              project.title === 'Ramdan2025' ||
              project.title === 'dh25' ||
              project.title === 'Ramdan2026'
                ? 1
                : selectedKey,
            tips,
            ...(selectedRewards.length !== 0 && {
              street: values?.street,
              building_number: values.building_number,
              zip_code: values.zip_code,
              city: values?.city,
            }),
            recurring: selectedKey === 0 ? false : true,
            reward_quantities: rewardQuantities,
            answers: _answer || [],
          },
          reward_ids: rewards,
        }),
        redirect: 'follow',
      })
        .then(async (result) => {
          setIsProcessing(false);
          setClientSecret(result?.payment_intent?.client_secret);
          setTotalAmount(result?.payment_intent?.amount);
          localStorage.setItem('rewards', JSON.stringify(result?.reward_ids));
          localStorage.setItem(
            'reward_quantities',
            JSON.stringify(rewardQuantities)
          );
          localStorage.setItem(
            'payment_intent_customer',
            JSON.stringify(result?.payment_intent?.customer)
          );
          setStripeBtn(true);
          setTokenId(result?.payment_intent?.id);
          setCustomer(result?.payment_intent?.customer);

          if (selectedKey > 0) {
            if (
              ['succeeded', 'processing'].includes(
                result?.payment_intent?.status
              )
            ) {
              await recurringDirectPayment(
                result?.payment_intent?.customer,
                result?.payment_intent?.payment_method,
                values
              );
              return;
            }

            await onSubmitPayPalPayment(
              values,
              result?.payment_intent?.customer
            );
          } else {
            await onSubmitPayment(values);
          }
        })
        .catch(() => {
          setIsProcessing(false);
          setMessage('Something wrong');
        });
    }

    if (paymentType === 'paypal') {
      localStorage.setItem(
        'after_redirect',
        JSON.stringify({
          ...values,
          projectTitle: new URLSearchParams(search).get('name') ?? '',
        })
      );
      localStorage.setItem('tips', JSON.stringify(tips));
      localStorage.setItem('amount', JSON.stringify(donationAmount));

      if (selectedRewards?.length) {
        localStorage.setItem('goodies', getRewardsPriceParam());
        localStorage.setItem(
          'reward_quantities',
          JSON.stringify(rewardQuantities)
        );
      } else {
        localStorage.removeItem('goodies');
        localStorage.removeItem('reward_quantities');
      }

      setIsProcessing(true);

      fetch('create_payment', {
        method: 'POST',
        body: JSON.stringify({
          email: user?.email == null ? values.email : user?.email,
          project_id,
          amount,
          tips,
          reward_ids: rewards,
          reward_quantities: rewardQuantities,
          return_url: getUrl,
          lottery: values?.lottery || false,
          anonymous: values?.anonymous == undefined ? false : values?.anonymous,
          message: values?.message == undefined ? '' : values?.message,
          ...(user !== null && { user_id: user?.id }),
          ...(user === null && {
            first_name: values.first_name,
            last_name: values.last_name,
          }),
          ...(selectedRewards.length !== 0 && {
            street: values?.street,
            building_number: values.building_number,
            zip_code: values.zip_code,
            city: values?.city,
          }),
        }),
      })
        .then(async (result) => {
          localStorage.setItem('rewards', JSON.stringify(result?.reward_ids));
          localStorage.setItem(
            'reward_quantities',
            JSON.stringify(rewardQuantities)
          );
          const geturl = result?.response?.links?.find(
            (item) => item?.rel === 'approval_url'
          );

          if (geturl) {
            window.open(`${geturl?.href}`, '_self');
            setIsProcessing(false);
          } else {
            setMessage('Something wrong');
            setIsProcessing(false);
          }

          if (selectedKey > 0) {
            await onSubmitPayPalPayment(values, '');
          } else {
            await onSubmitPayment(values);
          }
        })
        .catch(() => setIsProcessing(false));
    }
  };

  const param_id = id;

  console.log(rewards.length ?? 1, rewards);
  const onSubmitPayment = async (values) => {
    const _answer = getCurrentAnswersForPayload();

    setIsProcessing(true);

    const titleForStorage =
      project?.title != null && String(project.title) !== 'undefined'
        ? project.title
        : '';

    localStorage.setItem('title', titleForStorage);
    localStorage.setItem('tips', JSON.stringify(tips));
    localStorage.setItem('amount', JSON.stringify(donationAmount));

    if (selectedRewards?.length) {
      localStorage.setItem('goodies', getRewardsPriceParam());
      localStorage.setItem(
        'reward_quantities',
        JSON.stringify(rewardQuantities)
      );
    } else {
      localStorage.removeItem('goodies');
      localStorage.removeItem('reward_quantities');
    }

    const urlName = new URLSearchParams(search).get('name');
    const projectTitleForRedirect =
      project?.title != null && String(project.title) !== 'undefined'
        ? project.title
        : urlName && urlName !== 'undefined'
        ? urlName
        : '';

    localStorage.setItem(
      'after_redirect',
      JSON.stringify({
        ...values,
        projectTitle: projectTitleForRedirect,
      })
    );
    if (!stripe || !elements) {
      setIsProcessing(false);
      setMessage('Payment form is not ready, please try again');
      return;
    }

    const result = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/project/${project_id}/donation?donation=${amount}`,
      },
      redirect: 'if_required',
    });

    const { error, paymentIntent } = result;

    if (error) {
      setMessage(error.message);
      setIsProcessing(false);
    } else if (paymentIntent) {
      setIsProcessing(true);

      fetch('payments/direct_payment', {
        method: 'POST',
        body: JSON.stringify({
          project_id,
          support_level_id: values.support_level_id,
          first_name: values?.first_name,
          email: values?.email,
          last_name: values?.last_name,
          amount: donationAmount,
          tips,
          reward_ids: rewards,
          reward_quantities: rewardQuantities,
          answers: _answer,
          payment_intent: paymentIntent?.id,
          donation_type: selectedKey,
          anonymous: values?.anonymous,
          message: values?.message,
          lottery: values?.lottery || false,
          custom_name: resolveCustomName({
            ...formValues,

            ...values,
          }),
          custom_city: values.custom_city?.trim() ?? '',
          custom_message: values.custom_message?.trim() ?? '',
          selected_avatar: formValues.selected_avatar || '',
          ...(selectedRewards.length !== 0 && {
            street: values?.street,
            building_number: values.building_number,
            zip_code: values.zip_code,
            city: values?.city,
          }),
        }),
      })
        .then((resultDirect) => {
          if (resultDirect?.success === true) {
            setIsProcessing(false);
            redirect();
          } else {
            setIsProcessing(false);
            setMessage('Something wrong,please try again');
          }
        })
        .catch(() => {
          setIsProcessing(false);
          setMessage('Something wrong,please try again');
        });
    } else {
      setIsProcessing(false);
      setMessage('Unexpected Error');
    }
  };

  const onSubmitPayPalPayment = async (values, customerValue) => {
    setIsProcessing(true);

    const urlName = new URLSearchParams(search).get('name');
    const projectTitleForRedirect =
      project?.title != null && String(project.title) !== 'undefined'
        ? project.title
        : urlName && urlName !== 'undefined'
        ? urlName
        : '';
    const isFreitagPayment =
      String(projectTitleForRedirect).trim().toLowerCase() === 'freitag';

    localStorage.setItem(
      'after_redirect',
      JSON.stringify({
        ...values,
        selected_avatar: formValues.selected_avatar || '',
        projectTitle: projectTitleForRedirect,
      })
    );
    localStorage.setItem(
      'payment_return_context',
      JSON.stringify({
        projectId: project_id,
        projectUrl: isFreitagPayment ? 'freitag' : project?.url,
        projectTitle: projectTitleForRedirect,
        embeddedAction: Boolean(embeddedAction),
      })
    );

    if (!stripe || !elements) {
      setIsProcessing(false);
      setMessage('Payment form is not ready, please try again');
      return;
    }

    localStorage.setItem('tips', JSON.stringify(tips));
    localStorage.setItem('amount', JSON.stringify(donationAmount));

    if (selectedRewards?.length) {
      localStorage.setItem('goodies', getRewardsPriceParam());
      localStorage.setItem(
        'reward_quantities',
        JSON.stringify(rewardQuantities)
      );
    } else {
      localStorage.removeItem('goodies');
      localStorage.removeItem('reward_quantities');
    }

    setIsProcessing(true);

    const result = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url:
          isFreitagPayment
            ? `${window.location.origin}/payments/return?donation=${amount}&tips=${
                tips || 0
              }`
            : project.title === 'Ramdan2025'
            ? `${window.location.origin}/ramadan2025?donation=${amount}&tips=${
                tips || 0
              }`
            : project.title === 'Ramdan2026'
            ? `${
                window.location.origin
              }/rmdn2026-embed?donation=${amount}&tips=${tips || 0}`
            : `${window.location.origin}/project/${project_id}/donation?donation=${amount}`,
      },
      redirect: 'if_required',
    });

    const { error, paymentIntent } = result;

    if (error) {
      setMessage(error.message);
      setIsProcessing(false);
      setRecurringpayment(false);
    } else if (paymentIntent) {
      const confirmedPaymentMethodId = paymentIntent?.payment_method;
      setPaymentId(confirmedPaymentMethodId);
      if (customerValue) {
        // React state updates asynchronously. Pass the confirmed method
        // directly so recurring setup never receives a stale/empty ID.
        await recurringDirectPayment(
          customerValue,
          confirmedPaymentMethodId,
          values
        );
      } else {
        setIsProcessing(false);
        setMessage('Something wrong,please try again');
      }
    } else {
      setIsProcessing(false);
      setMessage('Unexpected Error');
    }
  };

  const handleCheckbox = () => {
    setStripeBtn(true);
    setMessage(null);
  };

  useEffect(() => {
    const urlName = new URLSearchParams(search).get('name');
    const value =
      project?.title != null && String(project.title) !== 'undefined'
        ? project.title
        : urlName && urlName !== 'undefined'
        ? urlName
        : '';

    if (value) {
      localStorage.setItem('projectTitle', value);
    }
  }, [project?.title, search]);

  const handelCloseModal = () => {
    setShowModal(false);
  };

  const getRedirectGoodies = () => {
    if (selectedRewards?.length) {
      return selectedRewards.map((item) => getRewardTotalPrice(item)).join(',');
    }
    const stored = localStorage.getItem('goodies');
    if (stored && stored.length) {
      return stored.replace(/,$/, '').replace(/,,/g, ',');
    }
    return '';
  };

  const getRedirectAmountAndTips = () => {
    const localSearchParams = new URLSearchParams(search || '');
    const urlDonation = localSearchParams.get('donation');
    const urlTips = localSearchParams.get('tips');
    const storedAmountRaw = localStorage.getItem('amount');
    const storedTipsRaw = localStorage.getItem('tips');
    const isReturnFromPayPal =
      localSearchParams.get('paymentId') != null ||
      localSearchParams.get('PayerID') != null;

    let redirectAmount = amount;
    let redirectTips = tips || '';

    const propAmountValid =
      amount != null &&
      amount !== '' &&
      !isNaN(Number(amount)) &&
      Number(amount) > 0;

    const propTipsValid =
      tips != null && tips !== '' && !isNaN(Number(tips)) && Number(tips) > 0;

    if (isReturnFromPayPal) {
      if (storedAmountRaw != null && storedAmountRaw !== 'null') {
        try {
          const parsed = JSON.parse(storedAmountRaw);
          if (parsed != null && !isNaN(parsed)) redirectAmount = parsed;
        } catch (_) {}
      }
      if (storedTipsRaw != null && storedTipsRaw !== 'null') {
        try {
          redirectTips = JSON.parse(storedTipsRaw);
        } catch (_) {}
      }
    } else if (!propAmountValid) {
      if (
        urlDonation != null &&
        urlDonation !== '' &&
        !isNaN(Number(urlDonation))
      ) {
        redirectAmount = Number(urlDonation);
      } else if (storedAmountRaw != null && storedAmountRaw !== 'null') {
        try {
          const parsed = JSON.parse(storedAmountRaw);
          if (parsed != null && !isNaN(parsed)) redirectAmount = parsed;
        } catch (_) {}
      }
    } else {
      redirectAmount = Number(amount);
    }

    if (!isReturnFromPayPal) {
      if (propTipsValid) {
        redirectTips = Number(tips);
      } else if (urlTips != null && urlTips !== '' && !isNaN(Number(urlTips))) {
        redirectTips = Number(urlTips);
      } else if (storedTipsRaw != null && storedTipsRaw !== 'null') {
        try {
          redirectTips = JSON.parse(storedTipsRaw);
        } catch (_) {}
      } else if (tips) {
        redirectTips = tips;
      }
    }

    return { redirectAmount, redirectTips };
  };

  const redirect = () => {
    const urlName = new URLSearchParams(search).get('name');
    const afterRedirect = JSON.parse(
      localStorage.getItem('after_redirect') ?? '{}'
    );
    const storedProjectTitle = localStorage.getItem('projectTitle');
    const proTitle = localStorage.getItem('title');

    const title =
      (project?.title != null && String(project.title) !== 'undefined'
        ? project.title
        : null) ||
      (urlName && urlName !== 'undefined' ? urlName : null) ||
      (afterRedirect?.projectTitle && afterRedirect.projectTitle !== 'undefined'
        ? afterRedirect.projectTitle
        : null) ||
      (storedProjectTitle && storedProjectTitle !== 'undefined'
        ? storedProjectTitle
        : null) ||
      (proTitle && proTitle !== 'undefined' ? proTitle : null);

    const validTitle = [title, proTitle].find(
      (t) => t != null && t !== '' && String(t).trim() !== 'undefined'
    );

    const { redirectAmount, redirectTips } = getRedirectAmountAndTips();
    const goodiesParam = getRedirectGoodies();
    const projectUrlParam = project?.url
      ? `&url=${encodeURIComponent(project.url)}`
      : '';

    try {
      localStorage.setItem('amount', JSON.stringify(redirectAmount));
      localStorage.setItem('tips', JSON.stringify(redirectTips));
      if (goodiesParam) {
        localStorage.setItem('goodies', goodiesParam);
        localStorage.setItem(
          'reward_quantities',
          JSON.stringify(rewardQuantities)
        );
      } else {
        localStorage.removeItem('goodies');
        localStorage.removeItem('reward_quantities');
      }
    } catch (_) {}

    if (project.is_ticketable) {
      history.push(
        `/events-success?${
          validTitle ? `title=${encodeURIComponent(validTitle)}` : ''
        }&amount=${redirectAmount}&tips=${redirectTips}&id=${project_id}${projectUrlParam}&g=${goodiesParam}`
      );
    } else if (embeddedAction === true) {
      const url = `/thank-you-page?${
        validTitle ? `title=${encodeURIComponent(validTitle)}` : ''
      }&amount=${redirectAmount}&tips=${redirectTips}&id=${project_id}${projectUrlParam}&g=${goodiesParam}
       ${
         sessionStorage.getItem('utm_campaign')
           ? `&utm_campaign=${sessionStorage.getItem('utm_campaign')}`
           : ''
       }${
        sessionStorage.getItem('utm_source')
          ? `&utm_source=${sessionStorage.getItem('utm_source')}`
          : ''
      }${
        sessionStorage.getItem('utm_medium')
          ? `&utm_medium=${sessionStorage.getItem('utm_medium')}`
          : ''
      }${
        sessionStorage.getItem('utm_term')
          ? `&utm_term=${sessionStorage.getItem('utm_term')}`
          : ''
      }${
        sessionStorage.getItem('utm_content')
          ? `&utm_content=${sessionStorage.getItem('utm_content')}`
          : ''
      }${
        sessionStorage.getItem('utm_adgroup')
          ? `&utm_adgroup=${sessionStorage.getItem('utm_adgroup')}`
          : ''
      }${
        sessionStorage.getItem('utm_placement')
          ? `&utm_placement=${sessionStorage.getItem('utm_placement')}`
          : ''
      }${
        sessionStorage.getItem('utm_device')
          ? `&utm_device=${sessionStorage.getItem('utm_device')}`
          : ''
      }${
        sessionStorage.getItem('utm_audience')
          ? `&utm_audience=${sessionStorage.getItem('utm_audience')}`
          : ''
      }${
        sessionStorage.getItem('utm_geo')
          ? `&utm_geo=${sessionStorage.getItem('utm_geo')}`
          : ''
      }${
        sessionStorage.getItem('utm_creative')
          ? `&utm_creative=${sessionStorage.getItem('utm_creative')}`
          : ''
      }${
        sessionStorage.getItem('utm_network')
          ? `&utm_network=${sessionStorage.getItem('utm_network')}`
          : ''
      }${
        sessionStorage.getItem('utm_id')
          ? `&utm_id=${sessionStorage.getItem('utm_id')}`
          : ''
      }`;

      const absoluteUrl = `${window.location.origin}${url}`;

      try {
        if (window.top && window.top !== window) {
          window.top.location.href = absoluteUrl;
          return;
        }
      } catch (_) {}

      try {
        const anchor = document.createElement('a');
        anchor.href = absoluteUrl;
        anchor.target = '_top';
        anchor.rel = 'noopener noreferrer';
        anchor.style.display = 'none';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
        return;
      } catch (_) {}

      window.location.href = absoluteUrl;
    } else {
      history.push(
        `/thank-you-page?${
          validTitle ? `title=${encodeURIComponent(validTitle)}` : ''
        }&amount=${redirectAmount}&tips=${redirectTips}&id=${project_id}${projectUrlParam}&g=${goodiesParam} ${
          sessionStorage.getItem('utm_campaign')
            ? `&utm_campaign=${sessionStorage.getItem('utm_campaign')}`
            : ''
        }${
          sessionStorage.getItem('utm_source')
            ? `&utm_source=${sessionStorage.getItem('utm_source')}`
            : ''
        }${
          sessionStorage.getItem('utm_medium')
            ? `&utm_medium=${sessionStorage.getItem('utm_medium')}`
            : ''
        }${
          sessionStorage.getItem('utm_term')
            ? `&utm_term=${sessionStorage.getItem('utm_term')}`
            : ''
        }${
          sessionStorage.getItem('utm_content')
            ? `&utm_content=${sessionStorage.getItem('utm_content')}`
            : ''
        }${
          sessionStorage.getItem('utm_adgroup')
            ? `&utm_adgroup=${sessionStorage.getItem('utm_adgroup')}`
            : ''
        }${
          sessionStorage.getItem('utm_placement')
            ? `&utm_placement=${sessionStorage.getItem('utm_placement')}`
            : ''
        }${
          sessionStorage.getItem('utm_device')
            ? `&utm_device=${sessionStorage.getItem('utm_device')}`
            : ''
        }${
          sessionStorage.getItem('utm_audience')
            ? `&utm_audience=${sessionStorage.getItem('utm_audience')}`
            : ''
        }${
          sessionStorage.getItem('utm_geo')
            ? `&utm_geo=${sessionStorage.getItem('utm_geo')}`
            : ''
        }${
          sessionStorage.getItem('utm_creative')
            ? `&utm_creative=${sessionStorage.getItem('utm_creative')}`
            : ''
        }${
          sessionStorage.getItem('utm_network')
            ? `&utm_network=${sessionStorage.getItem('utm_network')}`
            : ''
        }${
          sessionStorage.getItem('utm_id')
            ? `&utm_id=${sessionStorage.getItem('utm_id')}`
            : ''
        }`
      );
    }
  };

  useEffect(() => {
    setSelectedKey(
      project.title === 'Ramdan2025' ||
        project.title === 'dh25' ||
        project.title === 'Ramdan2026'
        ? 1
        : donationType
    );

    const isCardOnly =
      project.title === 'Ramdan2025' ||
      project.title === 'dh25' ||
      project.title === 'Ramdan2026'
        ? 1 > 0
        : donationType > 0;

    const isMethodChange =
      (donationType > 0 && selectedKey === 0) ||
      (donationType === 0 && selectedKey > 0) ||
      project.title === 'Ramdan2025' ||
      project.title === 'freitag' ||
      project.title === 'dh25' ||
      project.title === 'Ramdan2026';

    if (paymentIntentId && isMethodChange) {
      setShowStripeForm(false);

      fetch(`payments/intent_update?id=${paymentIntentId}`, {
        method: 'PATCH',
        body: JSON.stringify({ payment_intent: { recurring: isCardOnly } }),
      })
        .then(() => {
          setShowStripeForm(true);
        })
        .catch((err) => {
          console.log('err');
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [donationType, paymentIntentId]);

  useEffect(() => {
    if (project?.is_patreon) {
      setSelectedKey(0);
      dispatch({ type: 'SAVE_KEY', payload: 0 });
    }
  }, [dispatch, project?.is_patreon]);

  useEffect(() => {
    if (project?.title === 'freitag') {
      setSelectedKey(4);
      dispatch({ type: 'SAVE_KEY', payload: 4 });
    } else if (project?.title === 'dh25') {
      setSelectedKey(1);
      dispatch({ type: 'SAVE_KEY', payload: 1 });
    }
  }, [dispatch, project?.title]);

  useEffect(() => {
    dispatch({
      type: paymentConstants.SAVE_EMAIL,
      payload: project?.initiator_email || '',
    });
  }, [dispatch, project]);

  useEffect(() => {
    if (paymentType === 'card') {
      setStripeBtn(true);
      setMessage(null);
    }
    setShowPayButton(false);
    const showButtonTimer = setTimeout(() => setShowPayButton(true), 500);
    const updateIntentTimer = setTimeout(
      () => updateIntentHandle(formValues.anonymous),
      800
    );

    return () => {
      clearTimeout(showButtonTimer);
      clearTimeout(updateIntentTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRewards, amount, tips, paymentIntentId, formValues]);

  useEffect(() => {
    const run = async () => {
      if (payment_id != undefined) {
        redirect();

        const _answer = getStoredAnswersForPayload();

        setIsProcessing(true);

        await fetch('transfer_amount', {
          method: 'POST',
          body: JSON.stringify({
            account_id,
            payment_id,
            email: data?.email,
            project_id,
            lottery: data?.lottery || false,
            answers: _answer,
            amount: localStorage.getItem('amount'),
            tips: localStorage.getItem('tips'),
            reward_ids: getStoredRewards(),
            reward_quantities: getStoredRewardQuantities(),
            anonymous: data?.anonymous == undefined ? false : data?.anonymous,
            message: data?.message == undefined ? '' : data?.message,
            ...(user !== null && {
              user_id: user?.id,
              email: user?.email,
              first_name: user?.first_name,
              last_name: user?.last_name,
            }),
            ...(user === null && {
              first_name: data?.first_name,
              last_name: data?.last_name,
              street: data?.street,
              building_number: data.building_number,
              zip_code: data?.zip_code,
              city: data?.city,
            }),
          }),
        })
          .then((result) => {
            setIsProcessing(false);
            if (result?.payment_response?.state == 'approved') {
              dispatch({ type: paymentConstants.SAVE_KEY, payload: 0 });
            } else if (result?.message === 'payment already exist') {
              history.push(`/project/${result?.url}`);
            }
          })
          .catch(() => {
            setIsProcessing(false);
            setMessage('Something Wrong,Please try again later');
            store.addNotification({
              ...notification,
              title: 'Fehler!',
              type: 'danger',
              message: 'Something Wrong,Please try again later',
            });
          });
      }
    };

    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (payment_intent != undefined) {
      const getAnswers = getStoredJson('answers', []);
      const _answer = getStoredAnswersForPayload();

      const user_data = JSON.parse(localStorage.getItem('user_data'));
      const returnValues = { ...data, ...user_data, ...userData };
      setIsProcessing(true);

      const storedDonationType = Number(
        JSON.parse(localStorage.getItem('donation_type') || '0')
      );

      if (storedDonationType > 0) {
        const customerLocal = getStoredJson(
          'payment_intent_customer',
          null
        );
        recurringDirectPayment(
          customerLocal,
          undefined,
          user_data || data || {},
          payment_intent
        );
      } else {
        fetch('payments/direct_payment', {
          method: 'POST',
          body: JSON.stringify({
            donation_type: parseInt(localStorage.getItem('donation_type')),
            custom_name: resolveCustomName({
              ...formValues,

              ...user_data,

              ...userData,
            }),
            custom_city: returnValues.custom_city?.trim() ?? '',
            custom_message: returnValues.custom_message?.trim() ?? '',
            selected_avatar:
              userData.selected_avatar ||
              user_data?.selected_avatar ||
              data?.selected_avatar ||
              '',
            first_name: userData?.first_name
              ? userData?.first_name
              : user_data?.first_name,
            email: userData?.email ? userData?.email : user_data?.email,
            last_name: userData.last_name
              ? userData.last_name
              : user_data?.last_name,
            project_id,
            support_level_id: returnValues.support_level_id,
            amount: localStorage.getItem('amount'),
            tips: localStorage.getItem('tips'),
            reward_ids: getStoredRewards(),
            reward_quantities: getStoredRewardQuantities(),
            answers: _answer,
            payment_intent,
            anonymous: userData?.anonymous
              ? userData?.anonymous
              : data?.anonymous,
            message: userData?.message ? userData?.message : data?.message,
            lottery: userData?.lottery || false,
            ...(user !== null && { user_id: user?.id }),
            ...(getAnswers?.length !== 0 && {
              street: data?.street,
              building_number: data?.building_number,
              zip_code: data?.zip_code,
              city: data?.city,
            }),
          }),
        })
          .then((result) => {
            const titleToStore =
              project?.title != null && String(project.title) !== 'undefined'
                ? project.title
                : '';

            localStorage.setItem('title', titleToStore);

            if (result?.success === true) {
              setIsProcessing(false);
              redirect();
              dispatch({ type: paymentConstants.SAVE_KEY, payload: 0 });
            } else if (result?.success === false) {
              setIsProcessing(false);
              history.push(`/project/${result?.url}`);
              setMessage('');
            } else {
              setIsProcessing(false);
              setMessage('Something wrong,please try again');
            }
          })
          .catch(() => {
            setIsProcessing(false);
            setMessage('Something wrong,please try again');
          });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const hasAddressRequired = selectedRewards.some(
      (reward) => reward.address_required
    );
    setGoodiesRequiresAddress(hasAddressRequired);
  }, [selectedRewards]);

  useEffect(() => {
    if (isLoggedIn && !showModal) {
      setDoPayment(true);
    }
  }, [isLoggedIn, showModal]);

  const recurringDirectPayment = async (
    customerValue,
    confirmedPaymentMethodId = paymentId,
    submittedValues = userData,
    paymentIntentToken
  ) => {
    const payment_intent_id_local = JSON.parse(
      localStorage.getItem('payment_intent_id')
    );
    const userLocal = JSON.parse(localStorage.getItem('user'));
    const rewardsLocal =
      selectedRewards.length > 0
        ? selectedRewards
            .map((reward) => reward?.id?.toString())
            .filter(Boolean)
        : getStoredRewards().map((rewardId) => rewardId?.toString());
    const recurringRewardQuantities =
      selectedRewards.length > 0
        ? rewardQuantities
        : getStoredRewardQuantities();
    const donationTypeForFinalization = paymentIntentToken
      ? Number(getStoredJson('donation_type', selectedKey))
      : project.title === 'Ramdan2025' ||
        project.title === 'dh25' ||
        project.title === 'Ramdan2026'
      ? 1
      : selectedKey;

    return fetch('payments/recurring_direct_payment', {
      method: 'POST',
      body: JSON.stringify({
        first_name: userLocal?.first_name ?? submittedValues?.first_name,
        last_name: userLocal?.last_name ?? submittedValues?.last_name,
        email: userLocal?.email ?? submittedValues?.email,
        user_id: userLocal?.id,
        custom_name: resolveCustomName({
          ...formValues,
          ...submittedValues,
        }),
        custom_city: submittedValues?.custom_city?.trim() ?? '',
        custom_message: submittedValues?.custom_message?.trim() ?? '',
        selected_avatar:
          submittedValues?.selected_avatar || formValues.selected_avatar || '',
        project_id,
        support_level_id: submittedValues?.support_level_id || supportLevelId,
        amount:
          Number(JSON.parse(localStorage.getItem('amount'))) > 5
            ? Number(JSON.parse(localStorage.getItem('amount')))
            : amount,
        tips:
          tips !== 0 ? tips : Number(JSON.parse(localStorage.getItem('tips'))),
        token:
          paymentIntentToken || paymentIntentId || payment_intent_id_local,
        payment_id: confirmedPaymentMethodId,
        customer: customerValue,
        message: submittedValues?.message,
        anonymous: submittedValues?.anonymous,
        lottery: submittedValues?.lottery || false,
        donation_type: donationTypeForFinalization,
        ...(selectedRewards.length !== 0 && {
          street: submittedValues?.street,
          building_number: submittedValues?.building_number,
          zip_code: submittedValues?.zip_code,
          city: submittedValues?.city,
        }),
        reward_ids: rewardsLocal || [],
        reward_quantities: recurringRewardQuantities,
      }),
      redirect: 'follow',
    })
      .then((result) => {
        if (result?.success !== true) {
          throw new Error(
            result?.error || 'Recurring payment could not be completed'
          );
        }

        setIsProcessing(false);
        redirect();
        dispatch({ type: paymentConstants.SAVE_KEY, payload: 0 });
      })
      .catch(() => {
        setIsProcessing(false);
        if (!embeddedAction) {
          setMessage('Something wrong');
        }
      });
  };

  const finalizeWalletPayment = async (
    confirmedPaymentIntent,
    submittedValues = formValues
  ) => {
    if (!confirmedPaymentIntent?.id) {
      throw new Error('Confirmed PaymentIntent is missing');
    }

    if (selectedKey > 0) {
      return recurringDirectPayment(
        confirmedPaymentIntent.customer,
        confirmedPaymentIntent.payment_method,
        submittedValues,
        confirmedPaymentIntent.id
      );
    }

    const result = await fetch('payments/direct_payment', {
      method: 'POST',
      body: JSON.stringify({
        project_id,
        support_level_id: supportLevelId,
        first_name: submittedValues?.first_name,
        last_name: submittedValues?.last_name,
        email: submittedValues?.email,
        amount: donationAmount,
        tips,
        reward_ids: rewards,
        reward_quantities: rewardQuantities,
        answers: getCurrentAnswersForPayload(),
        payment_intent: confirmedPaymentIntent.id,
        donation_type: selectedKey,
        anonymous: submittedValues?.anonymous,
        message: submittedValues?.message,
        lottery: submittedValues?.lottery || false,
        custom_name: resolveCustomName({
          ...formValues,
          ...submittedValues,
        }),
        custom_city: submittedValues?.custom_city?.trim() ?? '',
        custom_message: submittedValues?.custom_message?.trim() ?? '',
        selected_avatar:
          submittedValues?.selected_avatar || formValues.selected_avatar || '',
        ...(selectedRewards.length !== 0 && {
          street: submittedValues?.street,
          building_number: submittedValues?.building_number,
          zip_code: submittedValues?.zip_code,
          city: submittedValues?.city,
        }),
      }),
    });

    if (result?.success !== true) {
      throw new Error('Wallet payment could not be finalized');
    }

    setIsProcessing(false);
    redirect();
  };

  const walletFirstName = user?.first_name || formValues?.first_name;
  const walletLastName = user?.last_name || formValues?.last_name;
  const walletEmail = user?.email || formValues?.email;
  const walletFormIsValid =
    Boolean(walletFirstName && walletLastName && termsCheck) &&
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(walletEmail || '');

  const handleWalletError = useCallback(
    (error) => {
      setIsProcessing(false);
      setMessage(
        error?.message ||
          error ||
          'Wallet-Zahlung fehlgeschlagen. Bitte versuche es erneut.'
      );
    },
    [setIsProcessing]
  );

  return (
    <>
      <Spin spinning={isProcessing}>
        <InfoFormWrapper>
          <Form
            name="donation_info"
            onFinish={onFinish}
            validateMessages={formValidateMessages}
            scrollToFirstError={false}
          >
            <div className="info-input">
              <HeadingWithInfo
                info={
                  selectedRewards.length === 0
                    ? null
                    : goodiesRequiresAddress
                    ? `Für den Versand deines ${project?.is_ticketable ? 'Tickets' : 'Goodies'} erhält der Projektinitiator Zugriff auf deinen Namen, deine E-Mail-Adresse und deine Lieferadresse.`
                    : `Falls es für die Bereitstellung deines ${project?.is_ticketable ? 'Tickets' : 'Goodies'} erforderlich ist, erhält der Projektinitiator Zugriff auf deinen Namen und deine E-Mail-Adresse.`
                }
              >
                Persönliche Angaben
              </HeadingWithInfo>

              <FormItem
                name="first_name"
                label="Vorname"
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    first_name: e.target.value,
                  })
                }
                rules={[{ required: true }]}
              >
                <Input
                  className="personal-base-input"
                  size="large"
                  placeholder="Vorname"
                  onChange={handleCheckbox}
                />
              </FormItem>

              <FormItem
                name="last_name"
                label="Nachname"
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    last_name: e.target.value,
                  })
                }
                rules={[{ required: true }]}
              >
                <Input
                  className="personal-base-input"
                  size="large"
                  placeholder="Nachname"
                  onChange={handleCheckbox}
                />
              </FormItem>

              <FormItem
                name="email"
                label="Email"
                onChange={(e) =>
                  setFormValues({ ...formValues, email: e.target.value })
                }
                rules={[
                  {
                    required: true,
                    type: 'email',
                  },
                ]}
              >
                <Input
                  className="personal-base-input"
                  size="large"
                  type="email"
                  placeholder="E-Mail-Adresse"
                  onChange={handleCheckbox}
                />
              </FormItem>


              {goodiesRequiresAddress && selectedRewards.length !== 0 && (
                <>
                  <FormItem
                    name="city"
                    label="Stadt"
                    rules={[{ required: true }]}
                  >
                    <Input
                      className="personal-base-input"
                      size="large"
                      placeholder="Stadt"
                      onChange={handleCheckbox}
                    />
                  </FormItem>

                  <FormItem
                    name="street"
                    label="Straße"
                    rules={[{ required: true }]}
                  >
                    <Input
                      className="personal-base-input"
                      size="large"
                      placeholder="Straße"
                      onChange={handleCheckbox}
                    />
                  </FormItem>

                  <FormItem
                    name="zip_code"
                    label="Postleitzahl"
                    rules={[{ required: true }]}
                  >
                    <Input
                      className="personal-base-input"
                      size="large"
                      type="number"
                      placeholder="Postleitzahl"
                      onChange={handleCheckbox}
                    />
                  </FormItem>

                  <FormItem
                    name="building_number"
                    label="Hausnummer"
                    rules={[{ required: true }]}
                  >
                    <Input
                      className="personal-base-input"
                      size="large"
                      placeholder="Hausnummer"
                      onChange={handleCheckbox}
                    />
                  </FormItem>
                </>
              )}
            </div>

            {/*<div style={{ marginTop: '1rem' }}>*/}
            {/*  <FormItem*/}
            {/*    style={{ marginBottom: '8px' }}*/}
            {/*    name="terms"*/}
            {/*    onChange={(c) => {*/}
            {/*      updateIntentHandle(formValues.anonymous);*/}
            {/*      setTermsCheck(c.target.checked);*/}
            {/*    }}*/}
            {/*    className="remove-label compact-checkbox"*/}
            {/*    valuePropName="checked"*/}
            {/*    label="Zustimmung"*/}
            {/*    rules={[*/}
            {/*      {*/}
            {/*        validator: (_, value) =>*/}
            {/*          value*/}
            {/*            ? Promise.resolve()*/}
            {/*            : Promise.reject(new Error('Zustimmung erforderlich')),*/}
            {/*      },*/}
            {/*    ]}*/}
            {/*  >*/}
            {/*    <Checkbox>*/}
            {/*      Ich akzeptiere*/}
            {/*      <Link to="/anb" target="_blank">*/}
            {/*        die Nutzungsbedingungen*/}
            {/*      </Link>*/}
            {/*      für commonsplace und*/}
            {/*      <Link to="/datenschutz" target="_blank">*/}
            {/*        Datenschutzbestimmungen*/}
            {/*      </Link>*/}
            {/*      und bestätige, dass ich mindestens 16 Jahre alt bin.*/}
            {/*    </Checkbox>*/}
            {/*  </FormItem>*/}

            {/*  /!*{amount >= 300 && (*!/*/}
            {/*  /!*  <FormItem*!/*/}
            {/*  /!*    name="anonymous"*!/*/}
            {/*  /!*    valuePropName="checked"*!/*/}
            {/*  /!*    className="check-box compact-checkbox"*!/*/}
            {/*  /!*  >*!/*/}
            {/*  /!*    {!(*!/*/}
            {/*  /!*      getUrl?.includes('ramadan2025') ||*!/*/}
            {/*  /!*      getUrl?.includes('ramadan2026') ||*!/*/}
            {/*  /!*      getUrl?.includes('freitag') ||*!/*/}
            {/*  /!*      getUrl?.includes('dh25')*!/*/}
            {/*  /!*    ) && (*!/*/}
            {/*  /!*      <Checkbox*!/*/}
            {/*  /!*        onChange={(c) => {*!/*/}
            {/*  /!*          setFormValues({*!/*/}
            {/*  /!*            ...formValues,*!/*/}
            {/*  /!*            anonymous: c.target.checked,*!/*/}
            {/*  /!*          });*!/*/}
            {/*  /!*        }}*!/*/}
            {/*  /!*      >*!/*/}
            {/*  /!*        Ich fordere eine Spendenquittung beim Projektorganisator*!/*/}
            {/*  /!*        an.*!/*/}
            {/*  /!*      </Checkbox>*!/*/}
            {/*  /!*    )}*!/*/}
            {/*  /!*  </FormItem>*!/*/}
            {/*  /!*)}*!/*/}

            {/*  {param_id === '581' && (*/}
            {/*    <FormItem*/}
            {/*      name="lottery"*/}
            {/*      valuePropName="checked"*/}
            {/*      className="remove-label compact-checkbox"*/}
            {/*    >*/}
            {/*      <Checkbox>*/}
            {/*        Ich nehme an der*/}
            {/*        <ExternalLink*/}
            {/*          href="/"*/}
            {/*          onClick={(e) => {*/}
            {/*            e.preventDefault();*/}
            {/*            setShowLotteryModal(true);*/}
            {/*          }}*/}
            {/*        >*/}
            {/*          Umrah-Verlosung*/}
            {/*        </ExternalLink>*/}
            {/*        teil.*/}
            {/*      </Checkbox>*/}
            {/*    </FormItem>*/}
            {/*  )}*/}
            {/*</div>*/}

            {project?.title !== 'freitag' && <PreviewSection>
              {/* PreviewSection is a flex column with a 16px gap, so no extra margin here */}
              <HeadingWithInfo
                style={{ marginBottom: 0 }}
                info="So wird deine Unterstützung auf der Projektseite angezeigt. Du kannst deinen Anzeigenamen selbst wählen."
              >
                Vorschau
              </HeadingWithInfo>


              <SupportListItem
                project={project}
                time={moment().unix()}
                ticketCount={selectedRewards?.reduce((a,b) => a + b.quantity, 0) ?? 1}
                name={`${formValues.first_name} ${formValues.last_name}`}
                amount={previewDonationAmount}
                custom_message={previewMessageToShow}
                custom_city={previewCityToShow}
                custom_name={previewNameToShow || 'Dein Name'}
                selected_avatar={formValues.selected_avatar || defaultNeutralAvatar}
                iconType={formValues.selected_avatar || defaultNeutralAvatar}
              />

              <PersonalizeTriggerWrap>
                <PersonalizeButton
                  type="button"
                  onClick={() => setShowPersonalization((prev) => !prev)}
                >
                  Unterstützung personalisieren
                </PersonalizeButton>

                <PersonalizeHint>
                  {/*Motiviere deine Geschwister, etwas zu dem Vorhaben*/}
                  {/*beizutragen!*/}
                </PersonalizeHint>
              </PersonalizeTriggerWrap>

              {showPersonalization && (
                <PersonalizePanel>
                  <div>
                    <PersonalizeLabel>Dein Avatar</PersonalizeLabel>
                    <AvatarRow>
                      {avatarOptions.map((avatar) => (
                        <AvatarOption
                          key={avatar.key}
                          type="button"
                          $active={formValues.selected_avatar === avatar.key}
                          $bg={avatar.bg}
                          $color={avatar.color}
                          onClick={() =>
                            setFormValues({
                              ...formValues,
                              selected_avatar: avatar.key,
                              custom_name:
                                avatar.key === 'haci'
                                  ? 'Ein Bruder im Herzen'
                                  : avatar.key === 'hijab'
                                  ? 'Eine Schwester im Herzen'
                                  : ['Ein Bruder im Herzen', 'Eine Schwester im Herzen'].includes(
                                      formValues.custom_name
                                    )
                                  ? 'Eine herzliche Seele'
                                  : formValues.custom_name,
                            })
                          }
                        >
                          {avatar.icon}
                        </AvatarOption>
                      ))}
                    </AvatarRow>
                  </div>

                  <PersonalizeGrid>
                    <PersonalizeField>
                      <PersonalizeLabel>Dein Anzeigename</PersonalizeLabel>
                      <SelectWrapper>
                        <StyledSelect
                          value={formValues.custom_name}
                          onChange={(e) => {
                            const customName = e.target.value;

                            setFormValues({
                              ...formValues,
                              custom_name: customName,
                              selected_avatar: getAvatarForCustomName(
                                customName,
                                formValues.selected_avatar,
                                defaultNeutralAvatar
                              ),
                            });
                          }}
                        >
                          <option value="Eine herzliche Seele">
                            Eine herzliche Seele
                          </option>
                          <option value="Ein Bruder im Herzen">
                            Ein Bruder im Herzen
                          </option>
                          <option value="Eine Schwester im Herzen">
                            Eine Schwester im Herzen
                          </option>
                          <option value="ownName">
                            {formValues.first_name === ''
                              ? 'Dein Name'
                              : `${formValues.first_name} ${formValues.last_name}`}
                          </option>
                          <option value="ownN">
                            {formValues.first_name === ''
                              ? 'Initialien : Dein N.'
                              : `${formValues.first_name} ${
                                  formValues.last_name
                                    ? `${formValues.last_name.charAt(0)}.`
                                    : ''
                                }`}
                          </option>
                          {/*<option value="ownDefine">*/}
                          {/*  Eigener Eingabebereich*/}
                          {/*</option>*/}
                        </StyledSelect>
                        <div className="arrow-symbol">▾</div>
                      </SelectWrapper>

                      {formValues.custom_name === 'ownDefine' && (
                        <Input
                          className="personal-base-input"
                          value={formValues.custom_defined_name}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,

                              custom_defined_name: e.target.value,
                            })
                          }
                          placeholder="Eigenen Namen eingeben"
                        />
                      )}
                    </PersonalizeField>

                    <PersonalizeField>
                      <PersonalizeLabel>Deine Stadt</PersonalizeLabel>
                      <Input
                        p
                        className="personal-base-input"
                        value={formValues.custom_city}
                        onChange={(e) =>
                          setFormValues({
                            ...formValues,
                            custom_city: e.target.value,
                          })
                        }
                        placeholder="Stadt eingeben (optional)"
                      />
                    </PersonalizeField>

                    <PersonalizeField>
                      <PersonalizeLabel>Deine Botschaft</PersonalizeLabel>
                      <Input.TextArea
                        className="personal-base-textarea"
                        maxLength={150}
                        value={formValues.custom_message}
                        onChange={(e) =>
                          setFormValues({
                            ...formValues,
                            custom_message: e.target.value,
                          })
                        }
                        placeholder=""
                      />
                      <CharCount>
                        {formValues.custom_message.length} / 150
                      </CharCount>
                    </PersonalizeField>
                  </PersonalizeGrid>

                  <PanelFooter>
                    <FooterTextButton
                      type="button"
                      onClick={() => {
                        setShowPersonalization(false);
                        setFormValues({
                          ...formValues,
                          selected_avatar: defaultNeutralAvatar,
                          custom_city: '',
                          custom_message: '',
                          custom_name: 'ownName',
                          custom_defined_name: '',
                        });
                      }}
                    >
                      Abbrechen
                    </FooterTextButton>

                    <FooterTextButton
                      type="button"
                      onClick={() => {
                        setShowPersonalization(false);
                      }}
                      $green
                    >
                      Speichern
                    </FooterTextButton>
                  </PanelFooter>
                </PersonalizePanel>
              )}
            </PreviewSection>}


            {/* paddingTop: Payment.css adds 0.4rem padding on mobile, which would make this gap 38px */}
            <div className="payment_container" style={{ marginTop: 32, paddingTop: 0 }}>
              <h2 className="payment_label_heading">Zahlungsmethode</h2>

              <div className="secure_message">
                Dies ist eine sichere und SSL-verschlüsselte Zahlung. Ihre
                Kreditkarte Details sind sicher.
              </div>

              {message && <div className="response_message">{message}</div>}

              <div>
                <div style={{ position: 'relative' }}>
                  {!walletFormIsValid && (
                    <button
                      type="button"
                      aria-label="Persönliche Angaben für Wallet-Zahlung vervollständigen"
                      onClick={() =>
                        setMessage(
                          'Bitte fülle Vorname, Nachname und eine gültige E-Mail-Adresse aus.'
                        )
                      }
                      style={{
                        zIndex: 20,
                        position: 'absolute',
                        inset: 0,
                        textAlign: 'center',
                        background: 'transparent',
                        height: '40px',
                        marginTop: 0,
                        cursor: 'pointer',
                        border: 'none',
                        width: '100%',
                      }}
                    />
                  )}

                  <div style={{ marginBottom: '10px' }}>
                    <Elements stripe={stripePromise}>
                      <StripeApplePay
                        redirect={redirect}
                        userData={formValues}
                        clientSecret={clientSecret}
                        updateIntentHandle={updateIntentHandle}
                        onPaymentConfirmed={finalizeWalletPayment}
                        onError={handleWalletError}
                        onProcessingChange={setIsProcessing}
                        totalAmount={
                          Number(amount) +
                          Number(tips) +
                          (selectedRewards?.reduce(
                            (prev, reward) => prev + getRewardTotalPrice(reward),
                            0
                          ) || 0)
                        }
                      />
                    </Elements>
                  </div>
                </div>

                {paymentType === 'card' &&
                  clientSecret &&
                  stripePromise &&
                  showStripeForm &&
                  selectedKey !== 0 && (
                    <Elements key={clientSecret} options={options} stripe={stripePromise}>
                      <RecurringPaymentForm
                        options={options}
                        selectedRewards={selectedRewards}
                        paymentType={paymentType}
                        project_id={project_id}
                        setPaymentId={setPaymentId}
                        amount={amount}
                        tips={tips}
                        setMessage={setMessage}
                        setIsProcessing={setIsProcessing}
                        isProcessing={isProcessing}
                        values={userData}
                        selectedKey={selectedKey}
                        isTicketable={project?.is_ticketable}
                        recurringPayment={recurringPayment}
                        setRecurringpayment={setRecurringpayment}
                        setElements={setElements}
                        setStripe={setStripe}
                      />
                    </Elements>
                  )}

                {paymentType === 'card' &&
                  clientSecret &&
                  stripePromise &&
                  selectedKey === 0 &&
                  showStripeForm &&
                  !customer && (
                    <div
                      className="payment_container"
                      style={{ marginTop: '1rem', marginBottom: '0px' }}
                    >
                      <Elements key={clientSecret} options={options} stripe={stripePromise}>
                        <StripeForm
                          showSummary={showSummary}
                          options={options}
                          selectedRewards={selectedRewards}
                          paymentType={paymentType}
                          project_id={project_id}
                          amount={amount}
                          tips={tips}
                          setMessage={setMessage}
                          setIsProcessing={setIsProcessing}
                          isProcessing={isProcessing}
                          values={userData}
                          selectedKey={selectedKey}
                          isTicketable={project?.is_ticketable}
                          project={project}
                          setElements={setElements}
                          setStripe={setStripe}
                          onSubmitHandle={() => {
                            if (selectedRewards.length) {
                              localStorage.setItem('goodies', getRewardsPriceParam());
                              localStorage.setItem(
                                'reward_quantities',
                                JSON.stringify(rewardQuantities)
                              );
                            } else {
                              localStorage.removeItem('goodies');
                              localStorage.removeItem('reward_quantities');
                            }

                            localStorage.setItem(
                              'projectTitle',
                              new URLSearchParams(search).get('name') ??
                                project?.title ??
                                ''
                            );
                          }}
                        />
                      </Elements>
                    </div>
                  )}
              </div>
            </div>
          </Form>

          <Modal showModal={showModal} handelCloseModal={handelCloseModal}>
            <LoginForm
              navigate={false}
              handelCloseModal={handelCloseModal}
              setDoPayment={setDoPayment}
            />
          </Modal>

          <Modal
            showModal={showLotteryModal}
            handelCloseModal={() => setShowLotteryModal(false)}
          >
            <ol
              style={{
                flexDirection: 'column',
                gap: '10px',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginBottom: '10px',
                }}
              >
                <H2>Informationen zur Umrah-Verlosung</H2>
              </div>

              <li>Die Teilnahme an der Umrah-Verlosung ist freiwillig.</li>

              <li>
                Der Gewinner wird kurz vor der Umrah-Reise für Blinde aus allen
                Teilnehmern zufällig ausgewählt, privat benachrichtigt und auf
                <a
                  href="https://www.instagram.com/makarim_reisen"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: 'green' }}
                >
                  Instagram
                </a>
                bekanntgegeben.
              </li>

              <li>
                Der Gewinner erhält eine Umrah-Reise von Makarim. Weitere
                Informationen findest Du unter
                <a
                  href="https://www.soultreat.de/makarim/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: 'green' }}
                >
                  https://www.soultreat.de/makarim/
                </a>
                .
              </li>

              <li>
                Die Verlosung ist islamkonform und wurde entsprechend geprüft
                und genehmigt.
              </li>

              <li>
                Der Gewinner kann das Reisedatum innerhalb von zwei Jahren,
                basierend auf den verfügbaren Angeboten von Soultreat/Makarim,
                frei wählen.
              </li>
            </ol>
          </Modal>
        </InfoFormWrapper>
      </Spin>
    </>
  );
};

export default PaymentMethod;
